import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { classNames } from "primereact/utils";

import { useStore } from "../../../../stores/StoreContext";

import "./ContentSidebar.scss";

interface IContentSidebarProps {
  children: string | ReactNode | ReactNode[];
}

const RawContentSidebarComponent: FunctionComponent<IContentSidebarProps> = ({ children }: IContentSidebarProps) => {
  const { sidebarStore } = useStore();

  const hideWidthInMilliseconds = 400;

  const widthTransition = `width ${hideWidthInMilliseconds}ms ease`;

  return (
    <div
      className={classNames("sidebar-wrapper", {
        "is-collapsed": sidebarStore.isCollapsed,
      })}
      style={{ transition: widthTransition }}
    >
      <div className="sidebar-content-container">{children}</div>
    </div>
  );
};

export const ContentSidebarComponent = observer(RawContentSidebarComponent);
